import { EuropeanMarket, EmergingMarket } from '@/creditflowresearch/domain/Market';
import { EmeaRegion } from '@/creditflowresearch/domain/Region';
import { AbsProduct, HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';
import URL from '@/creditflowresearch/Router/urlConstants';
import { IAccessGrant } from './IAccessGrant';
import { allOf, anyOf, not, matchByMarket, matchByDealMarket, matchByRegion, matchByProduct, matchByPath } from './matchers';
import {
  LEAGUE_TABLE_PATTERNS,
  ISSUER_AND_PARENT_PROFILE_PATTERNS,
  INDUSTRY_PATTERNS,
  NON_INDUSTRY_OVERVIEW_PATTERNS,
  DEAL_CARD_PATTERNS,
  matchByPagePath,
} from './pagePatterns';

export const ACCESS_GRANTS: IAccessGrant[] = [
  // TODO: remove when the European market opening period ends
  {
    id: 'european-market-open-access',
    enabled: true,
    match: allOf(
      anyOf(matchByProduct(HycProduct.PRODUCT_ID), matchByProduct(IgcProduct.PRODUCT_ID)),
      matchByMarket(EuropeanMarket.MARKET_ID),
    ),
  },
  // TODO: remove when the European market opening period ends
  {
    id: 'emerging-market-with-emea-open-access',
    enabled: true,
    match: allOf(
      matchByMarket(EmergingMarket.MARKET_ID),
      matchByRegion(EmeaRegion.REGION_ID),
    ),
  },
  // TODO: remove when the European market opening period ends
  {
    id: 'bond-screener-with-emea-open-access',
    enabled: true,
    match: allOf(
      matchByPath(new RegExp(URL.CORPORATE_BONDSCREENER)),
      anyOf(matchByProduct(HycProduct.PRODUCT_ID), matchByProduct(IgcProduct.PRODUCT_ID)),
    ),
  },
  // TODO: remove when the European market opening period ends
  {
    id: 'post-and-stat-pages-with-emea-open-access',
    enabled: true,
    match: anyOf(
      matchByPath(/^\/post-\d+/),
      matchByPath(/^\/stat-\d+/),
    ),
  },
  // TODO: remove when the European market opening period ends
  {
    id: 'league-table-open-access',
    enabled: true,
    match: allOf(
      matchByPagePath(...LEAGUE_TABLE_PATTERNS),
      anyOf(matchByProduct(HycProduct.PRODUCT_ID), matchByProduct(IgcProduct.PRODUCT_ID)),
      not(matchByProduct(AbsProduct.PRODUCT_ID)),
    ),
  },
  // TODO: remove when the European market opening period ends
  {
    id: 'issuer-parent-profile-open-access',
    enabled: true,
    match: matchByPagePath(...ISSUER_AND_PARENT_PROFILE_PATTERNS),
  },
  // TODO: remove when the European market opening period ends
  {
    id: 'industry-profile-open-access',
    enabled: true,
    match: allOf(
      matchByPagePath(...INDUSTRY_PATTERNS),
      not(matchByPagePath(...NON_INDUSTRY_OVERVIEW_PATTERNS)),
      anyOf(matchByProduct(HycProduct.PRODUCT_ID), matchByProduct(IgcProduct.PRODUCT_ID)),
      not(matchByProduct(AbsProduct.PRODUCT_ID)),
    ),
  },
  // TODO: remove when the European market opening period ends
  {
    id: 'deal-card-open-access',
    enabled: true,
    match: allOf(
      matchByPagePath(...DEAL_CARD_PATTERNS),
      anyOf(
        allOf(
          matchByDealMarket(EuropeanMarket.MARKET_ID),
          anyOf(matchByProduct(HycProduct.PRODUCT_ID), matchByProduct(IgcProduct.PRODUCT_ID)),
        ),
        allOf(
          matchByDealMarket(EmergingMarket.MARKET_ID),
          matchByRegion(EmeaRegion.REGION_ID),
        ),
      ),
    ),
  },
];
